import { ID, IMedia } from "@libs/interfaces/layouts"
import { Button, Dialog } from "@blueprintjs/core"
import { useState, isValidElement, CSSProperties  } from "react"

interface IGalleryItemProps {
    i: number
    url: IMedia | JSX.Element
    width?:number | string
    height?: number | string
    type?: "image" | "div" | "span" | "element"
    galleryId: ID
    gallery?: any[]
    to?: (i:number) => void
    padding?: number
    style?: CSSProperties
}
export const GalleryItem = ( 
{
    i, 
    url={ thumbnail: "", title: "" } as IMedia, 
    galleryId,
    gallery, 
    type, 
    width,
    height,
    to,
    style,
    ...props
}: IGalleryItemProps ) :JSX.Element => {
    const padding = props.padding || 0;
    const [isOpen, setIsOpen] = useState(false)
    const onOpen = () : void => {
        if(url)  {
            !gallery ? setIsOpen(!isOpen) : to ? to(i) : <></>
        } 
    } 
    let thumbnail : JSX.Element
    let mediaSrc = "", burl: JSX.Element = <></>
    if( !isValidElement(url)) {
        const durl: IMedia = {...url} as IMedia
        mediaSrc = durl.thumbnail || ""
    }
    else {
        burl = url
    }
    switch(type) {        
        case "image" :
            thumbnail = <img 
                src={ mediaSrc.toString() } 
                className="thumbnail gallery-item pointer bg-secondary-super-light " 
                style={{ minWidth: width, width, height,  }} 
                onClick={ onOpen }
                alt=""
            />
            break
        case "span": 
            thumbnail = <span 
                className={`thumbnail gallery-item pointer bg-secondary-super-light- `} 
                style={{backgroundImage: `url(${ mediaSrc })`, width, height, ...style }} 
                onClick={onOpen}
            />
            break
        case "element":
            thumbnail = <span 
                className={`thumbnail gallery-item pointer bg-secondary-super-light- `} 
                style={{ width, height, ...style, }}  
            >
                { burl }
            </span>
            break
        case "div":
        default:
            thumbnail = <div 
                className="thumbnail gallery-item pointer bg-secondary-super-light " 
                style={{ backgroundImage: `url(${ mediaSrc })`, width, height, ...style, }} 
                onClick={onOpen}
            />
            break
    }
    return <>
        {thumbnail}
        <Dialog
            isOpen={isOpen}
            onClose={onOpen}
            className="large flex-centered transparent"
        >
            <div className=" position-relative gallery-dialog"> 
                <img 
                    src={ mediaSrc.toString() } 
                    alt="" 
                    style={{ maxHeight:"90vh", width: "100%", maxWidth:800 }} 
                />
                <div className="position-absolute top right m-2">
                    <Button onClick={onOpen} icon="cross"></Button>
                </div>            
            </div>
        </Dialog>
    </>
}

export default GalleryItem